import { useState } from "react";
import { Button } from "@/components/ui/button";
import ClapIcon from "@/components/icons/ClapIcon";
import { cn } from "@/lib/utils";

interface Props {
  count: number;
  onClap: () => void;
  size?: "sm" | "default";
  className?: string;
  label?: boolean;
  liked?: boolean;
}

/**
 * Clapping-hands reaction drawn with the same stroke icon used across the navigation,
 * so reactions match every other icon in the app. Toggle — like/unlike the post.
 */
const ClapButton = ({ count, onClap, size = "sm", className, label = true, liked = false }: Props) => {
  const [pop, setPop] = useState(false);

  const handle = () => {
    setPop(true);
    window.setTimeout(() => setPop(false), 220);
    onClap();
  };

  return (
    <Button
      type="button"
      size={size}
      variant="ghost"
      onClick={(e) => { e.stopPropagation(); handle(); }}
      aria-label={liked ? "Unlike" : "Like"}
      className={cn("relative gap-2 text-muted-foreground hover:text-amber-400", liked && "text-amber-400", className)}
    >
      <ClapIcon className={cn("w-4 h-4 transition-transform", pop && "scale-125", liked && "fill-amber-400 text-amber-400")} />
      {label && <span className="tabular-nums text-xs">{count}</span>}
      {pop && !liked && (
        <span className="pointer-events-none absolute -top-3 left-1/2 -translate-x-1/2 text-[11px] text-amber-400 animate-in fade-in slide-in-from-bottom-2">
          +1
        </span>
      )}
    </Button>
  );
};

export default ClapButton;
